// ** Styled Components
import { StyledButtonPublic } from './styles'

interface IProps {
	to?: string
	href?: string
	form?: string
	style?: React.CSSProperties | undefined
	type?: 'button' | 'submit'
	size?: 'normal' | 'small'
	variant?: 'primary' | 'secondary' | 'tertiary'
	label: string
	color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning'
	onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
	className?: string
	disabled?: boolean
	fullWidth?: boolean
	startIcon?: JSX.Element
	isLoading?: boolean
	toUppercase?: boolean
}

export const ButtonPublic = ({
	to,
	href,
	size = 'normal',
	type = 'button',
	style,
	label,
	color = 'primary',
	variant = 'primary',
	onClick,
	className,
	disabled = false,
	fullWidth = false,
	startIcon,
	isLoading,
	toUppercase = true,
	...commonProps
}: IProps) => {
	const content = (
		<>
			{startIcon !== undefined && startIcon}
			{toUppercase ? label.toUpperCase() : label}
			{isLoading && '...'}
		</>
	)

	if (href) {
		return (
			<StyledButtonPublic
				as='a'
				href={href}
				target='_blank'
				rel='noopener noreferrer'
				style={style}
				className={className}
				color={color}
				variant={variant}
				$fullWidth={fullWidth}
				onClick={onClick}
				{...commonProps}
			>
				{content}
			</StyledButtonPublic>
		)
	}

	return (
		<StyledButtonPublic
			as='button'
			type={type}
			style={style}
			className={className}
			color={color}
			variant={variant}
			$fullWidth={fullWidth}
			disabled={disabled}
			onClick={onClick}
			{...commonProps}
		>
			{content}
		</StyledButtonPublic>
	)
}
